import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";
import InfoTooltipIcon from "components/CustomTooltip/InfoTooltipIcon";

import {getScoreTheme} from "../../../../../utils/ScoreColorCalculator";

import {greyishBlue700} from "assets/jss/main";

ProductGlobalScoring.propTypes = {
    score: PropTypes.number,
    validated: PropTypes.bool,
    onOpenDrawer: PropTypes.func
};

function ProductGlobalScoring({score = null, validated = true, onOpenDrawer}) {
    if (score == null && validated) {
        return null;
    }

    if (!validated) {
        return (
            <Badge
                rounded={true}
                indicator={'circle'}
                size={'large'}
                labelSize={14}
                color={'draft'}
                labelColor={greyishBlue700}
                isBold={false}
                border={true}
            >
                <div style={{
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <span>NA</span>
                    <span style={{display: 'flex', marginLeft: '5px'}}>
                        <InfoTooltipIcon color={greyishBlue700} titleId={'retailer.product.scoring.notValidated.tooltip'}/>
                    </span>
                </div>
            </Badge>
        );
    }

    const scoreTheme = getScoreTheme(score)

    return (
        <Badge
            rounded={true}
            indicator={'circle'}
            size={'large'}
            labelSize={14}
            color={scoreTheme.theme}
            labelColor={scoreTheme.color}
            isBold={false}
            border={true}
        >
            <div style={{
                display: 'flex',
                alignItems: 'center'
            }}>
                <span>
                    <FormattedMessage id={'retailer.product.scoring.drawer.score'} values={{score, max: 100}} />
                </span>
                <span style={{display: 'flex', marginLeft: '5px'}}>
                    <InfoTooltipIcon
                        color={scoreTheme.color}
                        titleId={'retailer.product.scoring.drawer.subtitle'}
                        onClick={onOpenDrawer}
                    />
                </span>
            </div>
        </Badge>
    );
}

export default ProductGlobalScoring;
